import { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export function ChangePasswordDialog() {
  const [open, setOpen] = useState(false);
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const reset = () => { setCur(""); setNw(""); setConfirm(""); };
  const submit = async () => {
    if (nw.length < 6) return toast.error("New password must be at least 6 characters");
    if (nw !== confirm) return toast.error("New passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Password changed successfully");
      setOpen(false); reset();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { setOpen(o); if (!o) reset(); }}>
      <DialogTrigger asChild>
        <button data-testid="change-password-trigger" className="w-full px-4 py-2.5 mb-2 bg-white/5 hover:bg-white/10 text-slate-300 rounded-lg font-medium flex items-center gap-2 transition-all border border-white/10">
          <KeyRound size={18} /> Change Password
        </button>
      </DialogTrigger>
      <DialogContent data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle>Change Password</DialogTitle>
          <DialogDescription>Update your account password. You will stay logged in.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 pt-2">
          <div><Label className="mb-1.5 block">Current Password</Label><Input type="password" data-testid="cp-current" value={cur} onChange={(e) => setCur(e.target.value)} /></div>
          <div><Label className="mb-1.5 block">New Password</Label><Input type="password" data-testid="cp-new" value={nw} onChange={(e) => setNw(e.target.value)} placeholder="At least 6 characters" /></div>
          <div><Label className="mb-1.5 block">Confirm New Password</Label><Input type="password" data-testid="cp-confirm" value={confirm} onChange={(e) => setConfirm(e.target.value)} /></div>
        </div>
        <DialogFooter>
          <Button onClick={submit} disabled={busy} data-testid="cp-submit" className="bg-[#0F4C81] hover:bg-[#0A3A66]">{busy ? "Saving…" : "Update Password"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
